export default (api) => ({
  login: (data) => api.post('/auth/login/credentials', data),
  verifyMFA: (data) => api.post('/auth/login', data),
  sendOTP: (data) => api.post('/auth/login/sms', data),
  resendOTP: (data) => api.post('/auth/login/sms/resend', data),
  getCurrentUser: () => api.get('/me'),
})
